import { newSampleKey } from '../../../utils/sampleDataTemplate';
import { KeyedSelect, SampleFieldset, SampleRow, TextAreaField } from './SampleFormControls';
import { playerOptions, removeAt, replaceAt, type SampleSectionProps } from './templateEditing';

export const NotesFieldset = ({ value, onChange, errorFor }: SampleSectionProps) => {
  const players = playerOptions(value.players);

  return (
    <SampleFieldset
      legend="Notes"
      addLabel="Add note"
      addTestId="sample-data-add-note"
      onAdd={() =>
        onChange({
          ...value,
          notes: [...value.notes, { key: newSampleKey('note'), playerKey: '', content: '' }],
        })
      }
    >
      {value.notes.map((note, index) => {
        const path = (field: string) => `notes[${index}].${field}`;
        return (
          <SampleRow
            key={note.key}
            label={`Note ${index + 1}`}
            removeLabel={`Remove note ${index + 1}`}
            removeTestId={`sample-data-remove-note-${index}`}
            onRemove={() => onChange({ ...value, notes: removeAt(value.notes, index) })}
          >
            <KeyedSelect
              label="Player"
              path={path('playerKey')}
              error={errorFor(path('playerKey'))}
              testId={`sample-data-note-player-${index}`}
              options={players}
              value={note.playerKey}
              placeholder="Choose a player"
              onChange={(playerKey) =>
                onChange({ ...value, notes: replaceAt(value.notes, index, { playerKey }) })
              }
            />
            <TextAreaField
              label="Note"
              path={path('content')}
              error={errorFor(path('content'))}
              testId={`sample-data-note-content-${index}`}
              value={note.content}
              onChange={(content) =>
                onChange({ ...value, notes: replaceAt(value.notes, index, { content }) })
              }
            />
          </SampleRow>
        );
      })}
    </SampleFieldset>
  );
};
